const opportunityCards: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(".opportunity-card");

if (opportunityCards.length > 0) {
  const cardButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll(".opportunity-card__button");

  opportunityCards.forEach(card => {
    card.addEventListener("click", e => {
      const target = e.target as HTMLElement;

      if (target.classList.contains("button") || target.classList.contains("button__image")) {
        e.preventDefault()
      }
    });
  });

  cardButtons.forEach(button => {
    button.addEventListener("click", e => {
      console.log("small button clicked")
    })
  })
}